import Axios from "axios";
import React, { useState } from "react";
import { api_url } from "../../../config";
import useStore from "../../../context/useStore";
import AideNir from "../../common/HorsConnexion/AideNir";
import Bouton from "../../common/HorsConnexion/Bouton";
import EcranResultat from "../../common/HorsConnexion/EcranResultat";
import { MESSAGE_SERVEUR_INDISPONIBLE, messageErreur } from "../../common/HorsConnexion/horsConnexion";
import MessageEtat from "../../common/HorsConnexion/MessageEtat";
import PageHorsConnexion from "../../common/HorsConnexion/PageHorsConnexion";
import SaisieNir from "../../common/HorsConnexion/SaisieNir";

const DEMO_NIR = "269054958815780";
const DEMO_NIR_MESSAGE =
  "Vous ne devez pas rentrer le numéro affiché sur l'image mais celui de votre propre carte vitale.";

/**
 * Réponse à une convocation en équipe pluridisciplinaire (lien du courrier).
 * Même appel qu'avant : PATCH epdetails/:epid/confirm-presence avec le jeton,
 * le NIR et la modalité choisie (EP_SANCTION_PRESENCES). Le refus s'affiche
 * dans la carte, sans notification en double.
 */
const ConfirmEpPresence = (props) => {
  const [state] = useStore();
  const presences = state.constants.items.EP_SANCTION_PRESENCES || [];
  const { token, epid: epId } = props.match.params;
  const [presence, setPresence] = useState("");
  const [nir, setNir] = useState("");
  const [erreurNir, setErreurNir] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  function envoyer(e) {
    e.preventDefault();
    if (!presence || isLoading) return;
    setIsLoading(true);
    setErreur(null);
    Axios.patch(api_url + `epdetails/${epId}/confirm-presence`, { token, nir, answer: presence })
      .then((res) => setSaved(res.data || true))
      .catch((err) => {
        const donnees = err.response && err.response.data;
        if (donnees && donnees.nir) setErreurNir(donnees.nir);
        else setErreur(messageErreur(donnees) || MESSAGE_SERVEUR_INDISPONIBLE);
      })
      .then(() => setIsLoading(false));
  }

  if (!token) {
    return (
      <PageHorsConnexion>
        <EcranResultat ton="danger" icone="croix" titre="Ce lien n'est plus valide">
          <p>Ce lien n'est plus valide ou vous avez déjà répondu.</p>
        </EcranResultat>
      </PageHorsConnexion>
    );
  }

  if (saved) {
    return (
      <PageHorsConnexion>
        <EcranResultat ton="succes" icone="coche" titre="Votre réponse est enregistrée">
          <p>Merci, votre réponse a bien été enregistrée.</p>
          <p>
            N'oubliez pas de compléter le verso de votre convocation et de nous l'adresser dans les délais
            impartis.
          </p>
        </EcranResultat>
      </PageHorsConnexion>
    );
  }

  return (
    <PageHorsConnexion>
      <section aria-labelledby="titre-presence-ep">
        <h1 id="titre-presence-ep">Votre présence à l'équipe pluridisciplinaire</h1>
        <p className="sous-titre">
          Dès réception de votre courrier de convocation, confirmez ici votre modalité de réponse.
        </p>

        <form onSubmit={envoyer} noValidate>
          <SaisieNir
            id="nir-ep-inp"
            label="Votre numéro de sécurité sociale"
            value={nir}
            onChange={(e) => {
              const valeur = e.target.value;
              // Le NIR du spécimen est refusé en ligne (plus d'alert()).
              if (valeur === DEMO_NIR) {
                setErreurNir(DEMO_NIR_MESSAGE);
              } else {
                setErreurNir(null);
                setNir(valeur);
              }
            }}
            erreur={erreurNir}
            aide={<AideNir />}
            autoFocus
          />

          <fieldset className="choix">
            <legend>Serez-vous présent(e) ?</legend>
            <div className="choix__options">
              {presences.map((p) => (
                <label key={p.id} className={"choix__option" + (presence === p.id ? " coche" : "")}>
                  <input
                    type="radio"
                    name="presence"
                    value={p.id}
                    checked={presence === p.id}
                    onChange={() => setPresence(p.id)}
                  />
                  {p.name}
                </label>
              ))}
            </div>
          </fieldset>

          {presence !== "" && (
            <>
              <MessageEtat ton="info" icone="info">
                Veuillez compléter le verso de votre convocation et nous l'adresser dans les délais
                impartis.
              </MessageEtat>
              {erreur && (
                <MessageEtat ton="danger" icone="alerte">
                  {erreur}
                </MessageEtat>
              )}
              <Bouton type="submit" charge={isLoading}>
                Envoyer ma réponse
              </Bouton>
            </>
          )}
        </form>
      </section>
    </PageHorsConnexion>
  );
};

export default ConfirmEpPresence;
